module.exports = __webpack_public_path__ + "static/img/40008 (1).19e7714.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40008 (1).webp
// module id = 6If/
// module chunks = 14